/* global angular */

var ngModule = angular.module('trends');

ngModule.controller('HomepageController', ['$scope', 'HistoricContext', 'MixpanelAdvancedSearch',
    function ($scope, HistoricContext, MixpanelAdvancedSearch) {
        $scope.selectedTab = 'observation';

        function onFinishAdvancedSearch() {
            var filterType = HistoricContext.getValue('search_filter_type_context');
            var filterName = HistoricContext.getValue('search_filter_name_context');
            var selectedTab = HistoricContext.getValue('category_selection');

            // If the filter info are empty, that means no advanced search was started yet,
            // so mixpanel message should not be sent.
            if ((filterType.length !== 0 && filterType !== null) || (filterName.length !== 0 && filterName !== null)) {

                var tab = 'Observations';
                if (selectedTab !== null && selectedTab !== 'group') {
                    tab = selectedTab.charAt(0).toUpperCase() + selectedTab.substring(1, selectedTab.length) + 's';
                    MixpanelAdvancedSearch.advancedSearch(filterName, filterType, tab);
                    // Clear search filter info after an advanced search finish.
                    MixpanelAdvancedSearch.clearSearchFilter();
                }
            }
        }

        window.onunload = onFinishAdvancedSearch;
        window.onscroll = onFinishAdvancedSearch;

        // the results in the filters should not be used if drilling down onto
        // a group page
        $scope.$watch('selectedTab', function (after) {
            if (after === 'group') {
                HistoricContext.insert('temporary_filter_context', {}, 'session');
            }
            else {
                var value = HistoricContext.getValue('homepage_filters');
                if (value) {
                    HistoricContext.insert('temporary_filter_context', value, 'session');
                }
            }

            $scope.$broadcast('updateContent', after);
        });
    }]);

ngModule.controller('GroupListController', ['$scope', 'Api', 'AjaxList',
    function ($scope, Api, AjaxList) {
        $scope.filters = {};
        $scope.selectedTab = 'sector';

        angular.forEach(Api.filters, function (v, k) {
            $scope.filters[k] = new AjaxList(Api.filters[k], {defaultParams: {order_by: 'description'}, cached: true});
            $scope.filters[k].loadNext();
        });
    }]);
